import {ReactNode, isValidElement} from "react";

import isArray from "lodash/isArray";

export default function reactNodeToString(
  node?: ReactNode
): string | undefined {
  if (node === undefined || node === null) {
    return;
  }

  if (isArray(node)) {
    return node
      .map(reactNodeToString)
      .filter((part) => part !== undefined)
      .join("");
  }

  if (isValidElement(node)) {
    return reactNodeToString(node.props.children);
  }

  return String(node);
}
